"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const utils_enums_grid_1 = require("@gcloud-npm/utils.enums.grid");
const utils_common_get_viewport_size_1 = __importDefault(require("@gcloud-npm/utils.common.get-viewport-size"));
/** getKindDeviceByViewportSize
 * @param {array} array - Original array
 * @param {array} newItems - Array of new items
 */
const getDeviceKindDependsOnViewPort = () => {
    // el mas pequeño de caso base
    let res = 'MOBILE';
    if (typeof window !== "undefined") {
        // tablet
        const { viewPortWidth } = (0, utils_common_get_viewport_size_1.default)();
        if (viewPortWidth >= utils_enums_grid_1.SETTINGS[utils_enums_grid_1.NAMES.TABLET].breakpoint) {
            res = 'TABLET';
        }
        // medium
        if (viewPortWidth >= utils_enums_grid_1.SETTINGS[utils_enums_grid_1.NAMES.MEDIUM].breakpoint) {
            res = 'MEDIUM';
        }
        // desktop
        if (viewPortWidth >= utils_enums_grid_1.SETTINGS[utils_enums_grid_1.NAMES.DESKTOP].breakpoint) {
            res = 'DESKTOP';
        }
        // bigdesktop
        if (viewPortWidth >= utils_enums_grid_1.SETTINGS[utils_enums_grid_1.NAMES.BIG_DESKTOP].breakpoint) {
            res = 'BIG_DESKTOP';
        }
        return res;
    }
    return res;
};
exports.default = getDeviceKindDependsOnViewPort;
//# sourceMappingURL=index.js.map